module.exports = __webpack_public_path__ + "img/logo.cf9bcc56.png";